<template>
  <div class="col-lg-12 p-0 mb-50">
    <div class="mt-30 container-style mb-30">
      <div class="p-20 activity-form">
        <div class="d-flex flex-row justify-content-between">
          <div class="d-flex flex-row align-items-center">
            <img src="static/img/activity-configurator/activity-form-description.svg" />
            <div class="new-heading">Activity Information</div>
          </div>
          <div class="d-flex align-items-center">
            <div v-if="selectedActivityTypeId && selectedActivityTypeId != 'defaultOption' && selectedActivity" class="custom-json-upload-btn float-right btn btn-info br-30 ml-20">
              <img class="upload-file-img" src="static/img/activity-configurator/activity-import-json.svg" />
              Import JSON
              <input type="file" id="activity-json-file" class="cursor_pointer json-file-upload" v-on:change="onSurveyFileSelection($event)" />
            </div>
            <span v-if="selectedActivityTypeId && selectedActivityTypeId != 'defaultOption' && selectedActivity" v-b-popover.hover.focus="importJsonToolTip" class="fa fa-info-circle m-1 p-1 cursor_pointer"> </span>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pl-0" v-if="(!selectedActivityTypeId || selectedActivityTypeId == 'defaultOption') && $route.params.activityId === 0">
          <div class="form-group">
            <h4 class="pt-10">
              Activity Type
              <span class="required">*</span>
            </h4>
            <select
              v-validate="'required|min:2'"
              name="activityType"
              v-model="selectedActivityTypeId"
              :class="{
                input: true,
                'color-light': selectedActivityTypeId == 'defaultOption',
                'is-danger': errors.has('activityType'),
                'is-success': !errors.has('activityType')
              }"
              class="form-control input-md activity-type h-40"
              required
              :disabled="isPublishedEdit"
              :tabindex="1"
            >
              <option value="defaultOption" disabled selected>
                Select an activity type
              </option>
              <option v-for="activity in activityTypes" v-bind:value="activity.id" :key="activity.id">
                {{ activity.type }}
              </option>
            </select>
            <span v-show="errors.has('activityType')" class="error-style">The Activity Type must be selected.</span>
          </div>
        </div>
        <form v-if="selectedActivityTypeId && selectedActivityTypeId != 'defaultOption' && selectedActivity">
          <div class="row">
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pl-0">
              <div class="form-group">
                <h4 class="pt-10">
                  Activity Type
                  <span class="required">*</span>
                </h4>
                <select
                  v-validate="selectedActivityConfig.type == 'R' ? 'required|min:2' : ''"
                  name="activityType"
                  v-model="selectedActivityTypeId"
                  :class="{
                    input: true,
                    'is-danger': errors.has('activityType'),
                    'is-success': !errors.has('activityType')
                  }"
                  class="form-control input-md activity-type h-40"
                  required
                  :tabindex="1"
                  :disabled="mode === 'revise' || isPublishedEdit"
                >
                  <option value="defaultOption" disabled>
                    Select an activity type
                  </option>
                  <!-- <option disabld value="defaultOption">Select</option> -->
                  <option v-for="activity in activityTypes" v-bind:value="activity.id" :key="activity.id">
                    {{ activity.type }}
                  </option>
                </select>
                <span v-show="errors.has('activityType')" class="error-style">The Activity Type must be selected.</span>
              </div>
              <div class="form-group" v-if="selectedActivityConfig.name == 'O' || selectedActivityConfig.name == 'R'">
                <h4 class="pt-10">
                  Name
                  <span class="required" v-if="selectedActivityConfig.name == 'R'">*</span>
                </h4>
                <input
                  type="text"
                  v-validate="selectedActivityConfig.name == 'R' ? 'required' : ''"
                  v-model="selectedActivity.name"
                  name="title"
                  :class="{
                    input: true,
                    'is-danger': errors.has('title'),
                    'is-success': !errors.has('title')
                  }"
                  class="form-control input-md"
                  placeholder="Name of the activity"
                  :required="selectedActivityConfig.name == 'R'"
                  :tabindex="3"
                  :disabled="mode === 'revise' || isPublishedEdit"
                />
                <span v-show="errors.has('title')" class="error-style">The name field must be filled.</span>
              </div>
              <div class="form-group" v-if="selectedActivityConfig.objective == 'O' || selectedActivityConfig.objective == 'R'">
                <h4 class="pt-10">
                  Objective
                  <span class="required" v-if="selectedActivityConfig.objective == 'R'">*</span>
                </h4>
                <textarea
                  type="text"
                  v-validate="selectedActivityConfig.objective == 'R' ? 'required' : ''"
                  v-model="selectedActivity.objective"
                  name="objective"
                  :class="{
                    input: true,
                    'is-danger': errors.has('objective'),
                    'is-success': !errors.has('objective')
                  }"
                  class="form-control input-md"
                  placeholder="Describe the purpose of the activity"
                  style="height: 132px"
                  :required="selectedActivityConfig.objective == 'R'"
                  :tabindex="5"
                  :disabled="isPublishedEdit"
                />
                <span v-show="errors.has('objective')" class="error-style">Describe the purpose of the activity</span>
              </div>

              <div class="form-group" v-if="selectedActivityConfig.therapeutic_area == 'O' || selectedActivityConfig.therapeutic_area == 'R'">
                <h4 class="pt-10">
                  Therapeutic Area
                  <span class="required" v-if="selectedActivityConfig.therapeutic_area == 'R'">*</span>
                </h4>
                <select
                  v-validate="selectedActivityConfig.therapeutic_area == 'R' ? 'required|min:2' : ''"
                  v-model="selectedActivity.therapeuticAreaId"
                  name="therapeuticArea"
                  :class="{
                    input: true,
                    'is-danger': errors.has('therapeuticArea'),
                    'is-success': !errors.has('therapeuticArea')
                  }"
                  class="form-control input-md"
                  @change="isTherapeuticAreaOther"
                  :required="selectedActivityConfig.therapeutic_area == 'R'"
                  :tabindex="8"
                  :disabled="mode === 'revise' || isPublishedEdit"
                >
                  <option value="defaultOption" disabled>
                    Select a therapeutic area
                  </option>
                  <option v-for="option in therapeuticAreas" v-bind:value="option.id" :key="option.id">
                    {{ option.name }}
                  </option>
                </select>
                <span v-show="errors.has('therapeuticArea')" class="error-style">The Therapeutic Area must be selected.</span>
              </div>
              <div class="form-group" v-if="therapeuticAreaIsOther && (selectedActivityConfig.therapeutic_area == 'O' || selectedActivityConfig.therapeutic_area == 'R')">
                <h4 class="pt-10">
                  Custom Therapeutic Area
                </h4>
                <textarea
                  type="text"
                  maxlength="150"
                  v-model="selectedActivity.customTherapeuticArea"
                  name="customTherapeuticArea"
                  :class="{
                    input: true,
                    'is-danger': errors.has('customTherapeuticArea'),
                    'is-success': !errors.has('customTherapeuticArea')
                  }"
                  class="form-control input-md"
                  :required="selectedActivityConfig.therapeutic_area == 'R'"
                  :disabled="mode === 'revise' || isPublishedEdit"
                  :tabindex="11"
                />
                <span v-show="errors.has('customTherapeuticArea')" class="error-style">Custom Therapeutic area field must be filled.</span>
              </div>
              <div class="form-group" v-if="selectedActivityConfig.therapeutic_indication == 'O' || selectedActivityConfig.therapeutic_indication == 'R'">
                <h4 class="pt-10">
                  Therapeutic Indication
                  <span class="required" v-if="selectedActivityConfig.therapeutic_indication == 'R'">*</span>
                </h4>
                <input
                  type="text"
                  v-validate="selectedActivityConfig.therapeutic_indication == 'R' ? 'required' : ''"
                  v-model="selectedActivity.therapeuticIndication"
                  name="therapeuticIndication"
                  :class="{
                    input: true,
                    'is-danger': errors.has('therapeuticIndication'),
                    'is-success': !errors.has('therapeuticIndication')
                  }"
                  class="form-control input-md"
                  placeholder="Select a therapeutic indication"
                  :required="selectedActivityConfig.therapeutic_indication == 'R'"
                  :disabled="isPublishedEdit"
                  :tabindex="11"
                />
                <span v-show="errors.has('therapeuticIndication')" class="error-style">The Therapeutic indication field must be filled.</span>
              </div>
              <div class="form-group clearfix" v-if="selectedActivityConfig.custom_footer == 'O' || selectedActivityConfig.custom_footer == 'R'">
                <h4 class="pt-6 grpdwn">Custom Footer</h4>
                <quill-editor class="bg-white" name="customFooter" v-model="selectedActivity.customFooterText" :options="editorOptionForCustomFooter" v-on:change="characterLimitValidation($event)" :tabindex="13" :disabled="isPublishedEdit"></quill-editor>
                <span v-show="customFooterHasError" class="error-style">Custom Footer field must be filled.</span>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pl-0 ml-60">
              <div class="form-group" v-if="selectedActivityConfig.abbreviation == 'O' || selectedActivityConfig.abbreviation == 'R'">
                <h4 class="pt-10">
                  Abbreviation
                  <span class="required" v-if="selectedActivityConfig.abbreviation == 'R'">*</span>
                </h4>
                <input
                  type="text"
                  v-validate="selectedActivityConfig.abbreviation == 'R' ? 'required' : ''"
                  v-model="selectedActivity.abbreviation"
                  name="abbreviation"
                  :class="{
                    input: true,
                    'is-danger': errors.has('abbreviation'),
                    'is-success': !errors.has('abbreviation')
                  }"
                  class="form-control input-md"
                  placeholder="Activity abbreviation"
                  :required="selectedActivityConfig.abbreviation == 'R'"
                  :tabindex="2"
                  :disabled="mode === 'revise' || isPublishedEdit"
                />
                <span v-show="errors.has('abbreviation')" class="error-style">The Abbreviation field must be filled.</span>
              </div>
              <div class="form-group pr-0" v-if="selectedActivityConfig.completed_by == 'O' || selectedActivityConfig.completed_by == 'R'">
                <div class="multiselect filter-form-box" id="completedBySelectBox" ref="completed-by-select">
                  <div class="selectBox" @click="showCheckboxesCompletedBy">
                    <h4 class="pt-10">
                      Permissions<span
                        v-b-popover.hover.focus="'Select the role(s) for who can complete or view the activity. If more than one role is selected for Completed By, you will need to select which role each step can be completed by when configuring steps. If a role is Can View only, they will only be able to view the activity and not complete it.'"
                        class="fa fa-info-circle m-1 p-1"
                      ></span>
                      <span class="required" v-if="selectedActivityConfig.completed_by == 'R'">*</span>
                    </h4>
                    <div class="fakeclass">
                      <input
                        :class="{
                          input: true,
                          'is-danger': errors.has('authors'),
                          'is-success': !errors.has('authors')
                        }"
                        class="d-block form-control input-md cursor-pointer"
                        :value="getSelectedComplectedByText"
                        id="select-completed-by"
                        readonly
                        :tabindex="4"
                        v-show="!isDisplayCompletedByCheckBoxes"
                      />
                    </div>
                    <span v-show="errors.has('completedBy')" class="error-style">The user must be selected.</span>
                    <div class="overSelect hoverInOverSelect"></div>
                  </div>
                  <div id="showCheckboxesCompletedBy" class="select-scroll activity-builder-select-options" v-if="isDisplayCompletedByCheckBoxes">
                    <div class="col-md-4 col-lg-4 col-sm-12 p-0">
                      <div class="completed-by">Completed By</div>
                      <div class="check_label_input d-flex custom-control custom-checkbox" v-for="completedBy in completedByList" :key="completedBy.value">
                        <!-- disabledPermission(completedBy) -->
                        <input class="custom-control-input" :disabled="isPublishedEdit || selectedActivity.type == 'PRO (Patient Reported Outcome)' || selectedActivity.type == 'DRO (Device Reported Outcome)' || disabledPermission(completedBy)" :id="completedBy.value + '1'" type="checkbox" @change="onChangeCompletedByFilter(completedBy)" :checked="isCompletedBySelected(completedBy.value)" />
                        <label class="custom-control-label ml-0" :for="completedBy.value + '1'">{{ completedBy.name }}</label>
                      </div>
                    </div>
                    <div class="col-md-8 col-lg-8 col-sm-12 p-0">
                      <div class="can-view">Can View</div>
                      <div class="row">
                        <div class="col-md-7 p-0 m-0">
                          <div class="can-view">Study Team</div>
                          <div class="check_label_input d-flex custom-control custom-checkbox" v-for="canView in canViewListFiltered('study')" :key="canView.value">
                            <input class="custom-control-input" :id="canView.value" type="checkbox" @change="onChangeCanViewFilter(canView)" :checked="isCanViewBySelected(canView.value)" :disabled="isPublishedEdit" />
                            <label class="custom-control-label ml-0" :for="canView.value">{{ canView.name }}</label>
                          </div>
                        </div>
                        <div class="col-md-5 p-0 m-0">
                          <div class="can-view">Site Team</div>
                          <div class="check_label_input d-flex custom-control custom-checkbox" v-for="canView in canViewListFiltered('site')" :key="canView.value">
                            <input class="custom-control-input" :id="canView.value" type="checkbox" @change="onChangeCanViewFilter(canView)" :checked="isCanViewBySelected(canView.value)" :disabled="isPublishedEdit" />
                            <label class="custom-control-label ml-0" :for="canView.value">{{ canView.name }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="selectedActivityConfig.author == 'O' || selectedActivityConfig.author == 'R'">
                <h4 class="pt-10">
                  Author(s)
                  <span class="required" v-if="selectedActivityConfig.author == 'R'">*</span>
                </h4>
                <input
                  type="text"
                  v-validate="selectedActivityConfig.author == 'R' ? 'required' : ''"
                  v-model="selectedActivity.author"
                  name="authors"
                  :class="{
                    input: true,
                    'is-danger': errors.has('authors'),
                    'is-success': !errors.has('authors')
                  }"
                  class="form-control input-md"
                  placeholder="Name of the author"
                  :disabled="isPublishedEdit"
                  :required="selectedActivityConfig.author == 'R'"
                  :tabindex="6"
                />
                <span v-show="errors.has('authors')" class="error-style">The Author(s) field must be filled.</span>
              </div>

              <div class="form-group" v-if="selectedActivityConfig.copyright == 'O' || selectedActivityConfig.copyright == 'R'">
                <h4 class="pt-10">
                  Copyright
                  <span class="required" v-if="selectedActivityConfig.copyright == 'R'">*</span>
                </h4>
                <input
                  type="text"
                  v-validate="selectedActivityConfig.copyright == 'R' ? 'required' : ''"
                  v-model="selectedActivity.copyright"
                  name="copyRight"
                  :class="{
                    input: true,
                    'is-danger': errors.has('copyRight'),
                    'is-success': !errors.has('copyRight')
                  }"
                  class="form-control input-md"
                  placeholder="Copyright infomation "
                  :required="selectedActivityConfig.copyright == 'R'"
                  :disabled="isPublishedEdit"
                  :tabindex="7"
                />
                <span v-show="errors.has('copyRight')" class="error-style">The Copyright field must be filled.</span>
              </div>

              <div class="form-group col-md-5 p-0 mt__11" v-if="selectedActivityConfig.time_to_complete == 'O' || selectedActivityConfig.time_to_complete == 'R'">
                <h4 class="pt-10">
                  Minutes to Complete
                  <span class="required" v-if="selectedActivityConfig.time_to_complete == 'R'">*</span>
                </h4>
                <input
                  type="number"
                  v-validate="selectedActivityConfig.time_to_complete == 'R' ? 'required' : ''"
                  v-model="selectedActivity.timeToComplete"
                  name="timeToComplete"
                  :class="{
                    input: true,
                    'is-danger': errors.has('timeToComplete'),
                    'is-success': !errors.has('timeToComplete')
                  }"
                  class="form-control input-md"
                  placeholder="Enter minutes"
                  min="1"
                  max="999"
                  maxlength="3"
                  :tabindex="9"
                  :disabled="isPublishedEdit"
                />
                <span v-show="errors.has('timeToComplete')" class="error-style">Approximate minutes to complete field must be an integer with 3 digits max.</span>
              </div>
              <div class="form-group clearfix" v-if="selectedActivityConfig.group == 'O' || selectedActivityConfig.group == 'R'">
                <h4 class="pt-6 grpdwn">
                  Group
                  <span class="required" v-if="selectedActivityConfig.group == 'R'">*</span>
                </h4>
                <select v-validate="selectedActivityConfig.group == 'R' ? 'required' : ''" name="group" class="form-control input-md select-group Grop-dropdown" v-model="selectedActivity.groupId" v-on:change="onGroupChangeOptions($event)" :tabindex="12" :disabled="isPublishedEdit">
                  <option value="defaultOption">Select a group</option>
                  <option v-for="option in groups" v-bind:value="option.groupId" :key="option.groupId">
                    {{ option.name }}
                  </option>
                </select>
                <span v-show="errors.has('group')" class="error-style">The Group field must be filled.</span>
              </div>
              <div class="form-group mt__4" v-if="selectedActivityConfig.notes == 'O' || selectedActivityConfig.notes == 'R'">
                <h4 class="pt-10">Notes</h4>
                <textarea
                  type="url"
                  v-model="selectedActivity.notes"
                  name="Notes"
                  v-validate="selectedActivityConfig.notes == 'R' ? 'required' : ''"
                  :class="{
                    input: true,
                    'is-danger': errors.has('Notes'),
                    'is-success': !errors.has('Notes')
                  }"
                  class="form-control input-md textareaclass"
                  :disabled="isPublishedEdit"
                  :tabindex="13"
                  onkeyup="$(this).height(5);$(this).height($(this).prop('scrollHeight'))"
                />
              </div>
            </div>
            <!--col-md-5 ends here-->
          </div>

          <div class="row">
            <div class="divider"></div>
            <img src="static/img/activity-configurator/activity-form-setting.svg" />
            <div class="new-heading pad22">Settings</div>
            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 pl-0">
              <div class="switch-button d-flex pb-5" v-if="selectedActivityConfig.can_score_responses == 'D'">
                <div class="text col-md-7">Ability to score responses</div>
                <span class="setting-btn-text">Off</span>
                <div class="switch-option">
                  <label class="switch">
                    <input type="checkbox" v-model="selectedActivity.canScoreResponses" :disabled="isPublishedEdit" />
                    <div class="slider round" @keyup.enter="selectedActivity.canScoreResponses = !selectedActivity.canScoreResponses" tabindex="14"></div>
                  </label>
                  <span class="setting-btn-text">On</span>
                </div>
              </div>
              <div class="switch-button d-flex pb-5" v-if="selectedActivityConfig.allow_data_edit_checks == 'D'">
                <div class="text col-md-7">Allow site users to edit responses</div>
                <span class="setting-btn-text">Off</span>
                <div class="switch-option">
                  <label class="switch">
                    <input type="checkbox" v-model="selectedActivity.allowDataEditChecks" :disabled="isPublishedEdit" />
                    <div class="slider round" @keyup.enter="selectedActivity.allowDataEditChecks = !selectedActivity.allowDataEditChecks" tabindex="15"></div>
                  </label>
                  <span class="setting-btn-text">On</span>
                </div>
              </div>
              <div class="switch-button d-flex pb-5" v-if="selectedActivityConfig.is_watch_enabled == 'D'">
                <div class="text col-md-7">
                  Available for Apple Watch app
                  <span v-b-popover.hover.focus="'Apple Watch app includes support for Yes or No, Time only, Text Response, and Multiple Choice with single selection question types only. All other survey features are not currently available for use in the Apple Watch app.'" class="fa fa-info-circle p-1"></span>
                </div>
                <span class="setting-btn-text">Off</span>
                <div class="switch-option">
                  <label class="switch">
                    <input type="checkbox" v-model="selectedActivity.watchEnabled" :disabled="isPublishedEdit" />
                    <div class="slider round" @keyup.enter="selectedActivity.watchEnabled = !selectedActivity.watchEnabled" tabindex="16"></div>
                  </label>
                  <span class="setting-btn-text">On</span>
                </div>
              </div>
              <div class="switch-button d-flex pb-5" v-if="selectedActivityConfig.showNumericLabels == 'O' || selectedActivityConfig.showNumericLabels == 'D'">
                <div class="text col-md-7 color_666669">
                  Hide Step Numbers
                </div>
                <span class="setting-btn-text">Off</span>
                <div class="switch-option">
                  <label class="switch">
                    <input type="checkbox" @change="restrictHideStepNumbering" v-model="selectedActivity.hideNumericLabels" :disabled="isPublishedEdit" />
                    <div class="slider round" @keyup.enter="selectedActivity.hideNumericLabels = !selectedActivity.hideNumericLabels" tabindex="18"></div>
                  </label>
                  <span class="setting-btn-text">On</span>
                </div>
              </div>
              <div class="switch-button d-flex" v-if="selectedActivityConfig.custom_participant_messaging == 'D' || selectedActivityConfig.custom_participant_messaging == undefined">
                <div class="text col-md-7">Custom Participant Messaging</div>
                <span class="setting-btn-text">Off</span>
                <div class="switch-option">
                  <label class="switch">
                    <input type="checkbox" v-model="selectedActivity.customParticipantMessaging" :disabled="isPublishedEdit" />
                    <div class="slider round" @keyup.enter="selectedActivity.customParticipantMessaging = !selectedActivity.customParticipantMessaging" tabindex="14"></div>
                  </label>
                  <span class="setting-btn-text">On</span>
                </div>
              </div>
              <div class="switch-button d-flex">
                <div class="text col-md-7">
                  Enable data checks for responses
                </div>
                <span class="setting-btn-text">Off</span>
                <div class="switch-option">
                  <label class="switch">
                    <input type="checkbox" v-model="selectedActivity.dataChecksForResponses" :disabled="isPublishedEdit" />
                    <div class="slider round" @keyup.enter="selectedActivity.dataChecksForResponses = !selectedActivity.dataChecksForResponses" tabindex="14"></div>
                  </label>
                  <span class="setting-btn-text">On</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 pl-0 ml-40">
              <div class="switch-button d-flex pb-5">
                <div class="text col-md-6 color_666669">
                  Allow participant to save progress
                </div>
                <span class="setting-btn-text">Off</span>
                <div class="switch-option">
                  <label class="switch">
                    <input type="checkbox" v-model="selectedActivity.allowSaveProgress" :disabled="isPublishedEdit" />
                    <div class="slider round" @keyup.enter="selectedActivity.allowSaveProgress = !selectedActivity.allowSaveProgress" tabindex="18"></div>
                  </label>
                  <span class="setting-btn-text">On</span>
                </div>
              </div>
              <div class="switch-button d-flex pb-5">
                <div class="text col-md-6 color_666669">
                  Define devices for completion
                  <span
                    v-b-popover.hover.focus="
                      'Turn this feature on to control which devices can be used to complete this activity. When turned off, no restrictions exist and the activity can be completed on any supported device. Apple Watch app supports only Yes or No, Date & Time, Text Response, and Multiple Choice with single selection step types. All other types of questions are not currently available for use in the Apple Watch app. Additionally, text formatting is not supported.'
                    "
                    class="fa fa-info-circle m-1 p-1"
                  ></span>
                </div>
                <span class="setting-btn-text">Off</span>
                <div class="switch-option">
                  <label class="switch">
                    <input type="checkbox" v-model="selectedActivity.allowDevicesForCompletion" :disabled="isPublishedEdit" />
                    <div class="slider round" @keyup.enter="selectedActivity.allowDevicesForCompletion = !selectedActivity.allowDevicesForCompletion" @click="clearSelectedDevices()" tabindex="18"></div>
                  </label>
                  <span class="setting-btn-text">On</span>
                </div>
                <div class="col-lg-4 form-group pl-0" style="margin-bottom: 0px !important;" v-if="selectedActivity.allowDevicesForCompletion">
                  <div class="multiselect filter-form-box" id="deviceSelectBox" ref="device-select">
                    <div class="selectBox" @click="showCompletionDevices">
                      <div class="fakeclass">
                        <input name="language" class="form-control input-md th-comman-select-box" :value="getSelectedDevices()" id="select-Language" readonly :tabindex="10" v-show="!isDeviceCompletion" />
                      </div>
                      <span v-show="errors.has('language')" class="error-style">The language must be selected.</span>
                      <div class="overSelect"></div>
                    </div>
                    <div id="showCompletionDevices" class="select-scroll activity-builder-select-options" v-if="isDeviceCompletion">
                      <div class="check_label_input d-flex custom-control custom-checkbox" v-for="(device, index) in listOfDevices" :key="index">
                        <input class="custom-control-input" :id="device.value" type="checkbox" @change="onDeviceChange(device)" :checked="isDeviceSelected(device.value)" :disabled="isPublishedEdit" />
                        <label class="custom-control-label ml-0" :for="device.value">
                          {{ device.name }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="switch-button d-flex pb-5">
                <div class="text col-md-6 color_666669">
                  Allow previous responses to be shown
                </div>
                <span class="setting-btn-text">Off</span>
                <div class="switch-option">
                  <label class="switch">
                    <input type="checkbox" v-model="selectedActivity.allowPreviousResponses" :disabled="isPublishedEdit" />
                    <div class="slider round" @keyup.enter="selectedActivity.allowPreviousResponses = !selectedActivity.allowPreviousResponses" tabindex="18"></div>
                  </label>
                  <span class="setting-btn-text">On</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-if="selectedActivityTypeId && selectedActivity">
            <div class="divider"></div>
            <img src="static/img/activity-configurator/activity-form-Tag.svg" />
            <div class="new-heading pad22">Tags</div>

            <div class="col-lg-3">
              <div class="multiselect filter-form-box" ref="tags-select">
                <div class="selectBox" @click="showCheckboxesTag">
                  <ul id="select-Language" class="activity-type-select pl-13" disabled>
                    <li v-if="selectedTagNames && selectedTagNames.length == 1" value selected="selected">
                      {{ selectedTagNames[0] }}
                    </li>
                    <li v-else-if="selectedTagNames && selectedTagNames.length > 1" value selected="selected">
                      Tags selected
                      <span class="no-of-tags">{{ selectedTagNamesString }} </span>
                    </li>
                    <li v-else value selected="selected">Select Tags</li>
                  </ul>
                  <div class="overSelect"></div>
                </div>
                <div id="showCheckboxesTags" class="select-scroll activity-builder-select-options" v-if="isDisplayTagCheckboxes">
                  <input type="text" class="language-search-bar" placeholder="Enter a tag name to filter" v-model="searchedTag" />
                  <div class="check_label_input d-flex" v-for="tag in searchedTagsList" :key="tag.id">
                    <input :id="tag.id" @change="onChangeTagFilter(tag)" type="checkbox" :checked="isTagSelected(tag.id)" :disabled="tag.disabled || isPublishedEdit" />

                    <label :for="tag.id">{{ tag.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

        <div class="row" v-if="selectedActivityTypeId && selectedActivityTypeId != 'defaultOption' && selectedActivity">
          <div class="float-right mb-18 btn p-0">
            <button type="button" class="continue-btn" v-on:click="createActivity()" tabindex="22" @keyup.enter="createActivity()" :disabled="isUploadJsonFile">
              Continue
            </button>
          </div>
          <div class="float-right mb-18 btn p-0" tabindex="21" @keyup.enter="skipForNow()">
            <button type="button" class="cancel-btn btn" v-on:click="skipForNow()">
              Cancel
            </button>
          </div>
        </div>
        <div class="requrired-field">
          <span class="required">*</span>&nbsp;
          <span>Required fields</span>
        </div>
      </div>
    </div>

    <importJsonActivitymodel v-if="isJsonUploadSuccess" :isSuccessIcon="true" title="Import JSON" description="JSON file successfully imported." />
    <importJsonActivitymodel v-if="jsonImageAvailable" submitLabel="OK" :onlySubmit="true" :isModelActions="true" cancelLabel="" title="Import JSON" description="Images within the JSON file will not be uploaded during the importation process. Please upload images after importation using the Configurator." @onSubmitClick="handleokimageJSON" />
    <importJsonActivitymodel :key="'import' + 1" v-if="isUploadJsonFile" :isModelActions="true" cancelLabel="Cancel" submitLabel="I understand" title="Import JSON" description="Importing your activity will replace the information you have already entered." @onCancelClick="handleCancel" @onSubmitClick="handleSubmit" @onModelClose="handleCancel" />
  </div>
</template>

<script>
import toastr from "toastr";
import _ from "lodash";
import swal from "sweetalert2";
import importJsonActivitymodel from "../common/dialog-box-model";
import * as alignmentService from "@/components/services/alignment-service.js";
import { quillEditor } from "vue-quill-editor";
export default {
  name: "activity-form",
  data() {
    return {
      taskId: null,
      jsonImageAvailable: false,
      isUploadJsonFile: false,
      isJsonUploadSuccess: false,
      activityId: null,
      revisionId: null,
      studyId: null,
      mode: null,
      dirty: null,
      selectedTagNames: [],
      languagesFilter: [],
      selectedLanguagesOnEdit: [],
      tagsFilter: [],
      searchedTag: "",
      completedByFilter: [],
      canViewFilter: [],
      selectedActivityTypeId: "defaultOption",
      selectedActivity: {},
      therapeuticAreaIsOther: false,
      defaultLanguage: "EN",
      orginalselectedActivity: {},
      customFooterLimit: 200,
      customFooterHasError: false,
      searchedLanguage: "",
      isDisplayLanguageCheckBoxes: false,
      isDisplayTagCheckboxes: false,
      isDisplayCompletedByCheckBoxes: false,
      eventListenerToHideLanguageDropdown: null,
      eventListenerToHideTagDropdown: null,
      eventListenerToHideCompletedByDropdown: null,
      eventListenerToHideDeviceDropdown: null,
      completedByList: [
        {
          name: "Call Center",
          value: "Call-Center"
        },
        {
          name: "Caregiver",
          value: "Observer/Caregiver"
        },
        {
          name: "Home Health",
          value: "Home-Health"
        },
        {
          name: "Patient/Participant",
          value: "Patient/Participant"
        },
        {
          name: "Principal Investigator",
          value: "Principal-Investigator"
        },
        {
          name: "Rater",
          value: "Rater"
        },
        // {
        //   name: "Site",
        //   value: "Site",
        // },
        {
          name: "Study Coordinator",
          value: "Study-Coordinator"
        },
        {
          name: "Sub Investigator",
          value: "Sub-Investigator"
        },
        {
          name: "Interviewer",
          value: "Interviewer"
        }
      ],
      canViewList: [
        {
          name: "Call Center",
          value: "Call-Center",
          team: "site"
        },
        {
          name: "Home Health",
          value: "Home-Health",
          team: "site"
        },
        {
          name: "Principal Investigator",
          value: "Principal-Investigator",
          team: "site"
        },
        {
          name: "Rater",
          value: "Rater",
          team: "site"
        },
        {
          name: "Site-Data Lock",
          value: "Site-DataLock",
          team: "site"
        },
        {
          name: "Study Coordinator",
          value: "Study-Coordinator",
          team: "site"
        },
        {
          name: "Sub Investigator",
          value: "Sub-Investigator",
          team: "site"
        },
        {
          name: "Clinical Research Associate (Blinded)",
          value: "CRA",
          team: "study"
        },
        {
          name: "Clinical Research Associate (Unblinded)",
          value: "CraUB",
          team: "study"
        },
        {
          name: "Data Management",
          value: "Data-Management",
          team: "study"
        },
        {
          name: "Quality",
          value: "Quality",
          team: "study"
        },
        {
          name: "Biostatistics",
          value: "Biostatistics",
          team: "study"
        },
        {
          name: "Interviewer",
          value: "Interviewer",
          team: "study"
        },
        {
          name: "Pharmacovigilance",
          value: "Pharmacovigilance",
          team: "study"
        }
      ],
      editorOptionForCustomFooter: {
        placeholder: "Enter footer content",
        modules: {
          toolbar: [["bold", "italic", "underline"]]
        }
      },
      selectedProgressBar: "none",
      selectedDevices: [],
      listOfProgressBar: [
        {
          name: "None",
          value: "none"
        },
        {
          name: "Pagination",
          value: "pagination"
        },
        {
          name: "Progress Bar",
          value: "progress bar"
        }
      ],
      isProgressIndicator: false,
      listOfDevices: [
        {
          name: "Phone",
          value: "phone"
        },
        {
          name: "Tablet",
          value: "tablet"
        },
        {
          name: "Watch",
          value: "watch"
        },
        {
          name: "Web Only",
          value: "website"
        }
      ],
      isDeviceCompletion: false,
      importJsonToolTip: {
        content: `
          <p class="mb-10">To upload an activity JSON file, you must first <b>Export JSON</b> from the 
          Activity Library of an existing activity. Then modify the content using a text editor, 
          such as Notepad, and lastly, <b>Import JSON</b> file. Modifications are strictly limited 
          to the following in order to avoid import errors:</p>
          <ul>
            <li>Changing existing values</li>
            <li>
              Toggle Copyright flag or edit Copyright text configured for the activity using
              the following syntax: “copyrightText”: “insert copyright text” added to the
              bottom of the JSON file
            </li>
            <li>Adding activity Scores</li>
            <li>Do not remove “questionType” attributes or other required fields for the activity</li>
            <li>Do not remove image IDs or links</li>
            <li>Do not alter the data structure of the activity or upload invalid JSON syntax</li>
          </ul>
        `,
        html: true
      },
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT
    };
  },
  props: {
    therapeuticAreas: {},
    activityTypes: {},
    formConfig: {},
    languages: {},
    tags: {},
    groups: {},
    isPublishedEdit: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.taskId = this.$route.params.taskId;
    this.init();
    this.startAutoSave();
  },
  destroyed() {
    document.removeEventListener("click", this.eventListenerToHideLanguageDropdown);
    document.removeEventListener("click", this.eventListenerToHideTagDropdown);
    document.removeEventListener("click", this.eventListenerToHideCompletedByDropdown);
    document.removeEventListener("click", this.eventListenerToHideDeviceDropdown);
  },
  components: {
    importJsonActivitymodel,
    quillEditor
  },
  computed: {
    displayTags() {
      return this.tags.slice().sort(function(a, b) {
        return a.name > b.name ? 1 : -1;
      });
    },
    getSelectedComplectedByText: {
      get() {
        if (this.completedByFilter && this.completedByFilter.length) {
          if (this.completedByFilter.length == 1) {
            return this.completedByFilter[0].name || this.completedByFilter[0].value;
          } else {
            return `Users (${this.completedByFilter.length})`;
          }
        } else {
          return "Select user type ";
        }
      }
    },

    selectedActivityConfig() {
      if (!this.selectedActivityTypeId) {
        return {};
      }
      if (this.formConfig && this.formConfig[this.selectedActivityTypeId]) {
        return this.formConfig[this.selectedActivityTypeId];
      }
      return {};
    },
    searchedLanguagesList() {
      if (!this.languages) {
        return [];
      }
      if (!this.languages.length) {
        return [];
      }
      const sortedLanguages = _.sortBy(this.languages, "name");
      return sortedLanguages.filter(language => language.display_name.toLowerCase().includes(this.searchedLanguage.toLowerCase()));
    },
    selectedTagNamesString() {
      if (this.selectedTagNames && this.selectedTagNames.length) {
        const selectedValuesString = this.selectedTagNames.length;
        return selectedValuesString;
      }
      return "";
    },
    searchedTagsList() {
      if (!this.displayTags) {
        return [];
      }
      if (!this.displayTags.length) {
        return [];
      }

      const tags = this.tags.filter(tag => tag.name.toLowerCase().includes(this.searchedTag.toLowerCase()));

      return _.orderBy(tags, [tag => tag.name.toLowerCase()]);
    }
  },
  watch: {
    $route(to, from) {
      if (to.params.activityId != from.params.activityId) {
        this.init();
      }
    },
    languages() {
      this.selectLanguageByCulture(this.defaultLanguage, true);
    },
    selectedProgressBar() {
      if (this.selectedProgressBar) {
        this.selectedActivity.selectedProgressIndicator = this.selectedProgressBar;
      }
    },
    selectedDevices() {
      if (this.selectedDevices) {
        this.selectedActivity.selectedDevices = this.selectedDevices;
      }
    },
    selectedActivityTypeId(newId, oldId) {
      if (this.selectedActivityTypeId) {
        this.onActivitySelection();
        this.selectedActivity.typeId = this.selectedActivityTypeId;
        if (this.activityTypes && this.activityTypes.length) {
          this.selectedActivity.type = this.activityTypes.filter(activity => activity.id == this.selectedActivity.typeId)[0].type;
        }
        if (oldId != "defaultOption") {
          this.completedByFilter = [];
        }
      }
    },
    isDisplayCompletedByCheckBoxes() {
      //setting User permission as per Activity type
      //Participant-facing User permission only
      if (this.selectedActivity.type == "PRO (Patient Reported Outcome)" || this.selectedActivity.type == "DRO (Device Reported Outcome)") {
        if (this.isDisplayCompletedByCheckBoxes) {
          this.$nextTick(() => {
            document.getElementById("Observer/Caregiver1").disabled = false;
            document.getElementById("Patient/Participant1").disabled = false;
          });
        }
      }
      //Activity Types both Site & participant-Facing
      else if (this.selectedActivity.type == "Survey" || this.selectedActivity.type == "Task") {
        //Do nothing
      }
      //Activity Type Site Facing Only
      else {
        if (this.isDisplayCompletedByCheckBoxes) {
          this.$nextTick(() => {
            document.getElementById("Observer/Caregiver1").disabled = true;
            document.getElementById("Patient/Participant1").disabled = true;
          });
        }
      }
      if (this.selectedActivity.completedBy) {
        this.activityTypePermission();
      }
    },
    selectedActivity: {
      handler() {
        this.resetAutoSave();
        if (this.dirty == null) {
          this.dirty = false;
        } else {
          this.dirty = true;
        }
      },
      deep: true
    }
  },
  methods: {
    init() {
      this.activityId = this.$route.params.activityId;
      this.revisionId = this.$route.params.revisionId ? this.$route.params.revisionId : this.$route.query.revisionId;
      this.studyId = this.$route.params.studyId;
      this.mode = this.$route.params.mode ? this.$route.params.mode : this.$route.query.mode;
      if (!this.mode && this.revisionId) {
        this.mode = "revise";
      }
      this.hideLanguageCheckBox();
      this.hideDeviceCheckBox();
      this.hideTagCheckBox();
      this.hideCompletedByCheckBox();
      this.setAllRolesInCanView();
      if ((this.$route.name === "activity-details" || this.$route.name === "study-activities-activity-details" || this.$route.name === "data-capture-form-activity-details") && this.activityId != "0") {
        this.getActivityFact();
        if (this.mode == "copy") {
          this.activityId = 0;
        }
        if (this.mode == "revise") {
          this.activityId = 0;
        }
      }
    },
    canViewListFiltered(team) {
      if (team == "site") {
        return this.canViewList.filter(roles => roles.team == "site");
      } else if (team == "study") {
        return this.canViewList.filter(roles => roles.team == "study");
      }
    },
    setAllRolesInCanView() {
      this.canViewList.map(role => {
        this.onChangeCanViewFilter(role);
      });
    },
    removeExistingScoring() {
      const all_questions = this.selectedActivity.questions;

      all_questions.forEach(question => {
        //For All the normal Questions
        if (question.score) {
          question.score = 0;
        }
        //for custom Scale
        if (question.scores) {
          for (let i = 0; i < question.scores.length; i++) {
            question.scores[i] = 0;
          }
        }
        // for dropdown, boolean, multi choice
        if (question.options && question.options.length > 0) {
          question.options.forEach(option => {
            option.score = 0;
          });
        }
        // if there are skip score in any question
        if (question.skipScore) {
          question.skipScore = 0;
        }
        // for Image choice
        if (question.languageImageOptions && question.languageImageOptions[0]) {
          const options = question.languageImageOptions[0].options;
          options.forEach(option => {
            option.score = 0;
          });
        }
        //for Index
        if (question.indexValues) {
          question.indexValues.forEach(ind => {
            ind[0].score = 0;
          });
        }
      });
    },
    clearSelectedDevices() {
      this.selectedDevices = [];
    },
    selectLanguageByCulture(culture, disabled) {
      const languageIndex = this.languages.findIndex(e => e.language_culture === culture);
      this.languages[languageIndex]["disabled"] = disabled;
      this.onChangeLanguageFilter(this.languages[languageIndex]);
    },
    handleCancel() {
      this.isUploadJsonFile = false;
      window.document.getElementById("activity-json-file").value = null;
    },
    getTherapeuticAreaName() {
      const therapeuticAreaSelected = this.therapeuticAreas.filter(item => item.id == this.selectedActivity.therapeuticAreaId)[0];
      this.selectedActivity.therapeuticArea = therapeuticAreaSelected.name;
    },
    handleokimageJSON() {
      this.isJsonUploadSuccess = true;
      setTimeout(() => {
        this.isJsonUploadSuccess = false;
        this.$router.push({
          name: "activity-library-homepage"
        });
      }, 3000);
    },
    handleSubmit() {
      const self = this;
      const fileObject = window.document.getElementById("activity-json-file");
      const surveyFile = fileObject.files[0];
      const fileread = new FileReader();
      fileread.onload = function(e) {
        const isJSONFile = self.isJSON(e.target.result);
        //check old alignment classes
        const formattedActivityData = self.checkOldAlignments(e.target.result);
        if (isJSONFile) {
          self.uploadSurveyJSONFile(formattedActivityData);
        } else {
          fileObject.value = null;
          this.isUploadJsonFile = false;
          toastr.error("Uploaded file is not in proper JSON format.");
        }
      };
      fileread.onerror = function() {
        // error occurred
        this.$toastr.error("JSON upload failed. Please try again.");
        event.target.value = null;
        return;
      };
      fileread.readAsText(surveyFile);
    },
    onModalClose() {},
    closeExportSuccessModal() {
      this.$refs.exportActivitySuccessModal.hide();
    },
    onSurveyFileSelection() {
      const fileObject = window.document.getElementById("activity-json-file");
      const jsonFile = fileObject.files[0];
      if (jsonFile && !jsonFile.type.startsWith("application/json")) {
        fileObject.value = null;
        toastr.error("Invalid file format to import JSON file. File extension must be .JSON.");
        return;
      }
      this.isUploadJsonFile = true;
    },
    isJSON(jsonString) {
      try {
        const activityData = JSON.parse(jsonString);
        if (activityData && typeof activityData === "object" && (Object.keys(activityData).includes("name") || Object.keys(activityData).includes("title"))) {
          return true;
        }
      } catch (e) {
        return false;
      }
      return false;
    },
    uploadSurveyJSONFile(jsonFile) {
      window.document.getElementById("activity-json-file").value = null;
      this.$api.uploadActivityJsonFile(jsonFile).then(
        response => {
          this.isUploadJsonFile = false;
          window.document.getElementById("activity-json-file").value = null;
          if (response.body.result.imageCopyStatusFailed && response.body.result.imageCopyStatusFailed == true) {
            this.jsonImageAvailable = true;
          } else {
            this.isJsonUploadSuccess = true;
            setTimeout(() => {
              this.isJsonUploadSuccess = false;
              this.$router.push({
                name: "activity-library-homepage"
              });
            }, 3000);
          }
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while importing the json file");
          window.document.getElementById("activity-json-file").value = null;
          this.isUploadJsonFile = false;
        }
      );
    },
    isTherapeuticAreaOther(event) {
      const selectedArea = this.therapeuticAreas.find(o => o.id == event.target.value);
      this.therapeuticAreaIsOther = !!(selectedArea !== undefined && (selectedArea.name == "Others" || selectedArea.name == "Other"));
      this.getTherapeuticAreaName();
    },
    auto_grow(element) {
      element.style.height = "5px";
      element.style.height = element.scrollHeight + "px";
    },
    getSelectedDevices() {
      const deviceNames = [];
      if (this.selectedDevices && this.selectedDevices.length) {
        this.selectedDevices.filter(device => {
          deviceNames.push(device.name);
        });
        return deviceNames;
      } else {
        return "Select devices";
      }
    },
    getSelectedLanguageText() {
      if (this.languagesFilter && this.languagesFilter.length) {
        if (this.languagesFilter.length == 1) {
          return this.languagesFilter[0].display_name;
        } else {
          return `Languages (${this.languagesFilter.length})`;
        }
      } else {
        return "Select a language";
      }
    },
    onActivitySelection() {
      this.$nextTick(() => {
        const fields = Object.keys(this.selectedActivityConfig);
        fields.forEach(field => {
          if (this.activityId == "0" && (this.selectedActivityConfig[field] == "R" || this.selectedActivityConfig[field] == "O")) {
            this.$set(this.selectedActivity, "");
          }
        });
      });
    },
    onGroupChangeOptions(event) {
      const groupId = event.target.value;
      const group = this.groups.filter(group => {
        return group.groupId == groupId;
      });
      if (group) {
        this.selectedActivity.groupName = group[0].name;
      }
    },
    restrictHideStepNumbering(event) {
      const selectedActivityType = this.activityTypes.find(o => o.id == this.selectedActivityTypeId);
      if (event.target.checked && selectedActivityType.type === "Task" && (this.selectedActivity.completedBy.includes("Observer/Caregiver") || this.selectedActivity.completedBy.includes("Patient/Participant"))) {
        this.showMessageForHideStepNumbersRestiction();
      }
    },
    isRestrictedForHideStepNumbers() {
      const selectedActivityType = this.activityTypes.find(o => o.id == this.selectedActivityTypeId);
      return selectedActivityType && selectedActivityType.type === "Task" && this.selectedActivity.hideNumericLabels && (this.selectedActivity.completedBy.includes("Observer/Caregiver") || this.selectedActivity.completedBy.includes("Patient/Participant"));
    },
    showMessageForHideStepNumbersRestiction() {
      toastr.error("Hiding step numbers is not permitted for an activity completed by a Participant or Caregiver. Please select a Site Team member role or disable this feature.");
    },
    getActivityFact() {
      this.$api
        .getActivityDetails(this.activityId, this.revisionId)
        .then(response => {
          this.selectedActivity = response.data.result;
          this.selectedProgressBar = this.selectedActivity.selectedProgressIndicator || "none";
          this.selectedDevices = this.selectedActivity.selectedDevices || [];
          /* By Default Show Numberic Lables should have to be checked */
          this.selectedActivity["hideNumericLabels"] = this.selectedActivity.hasOwnProperty("showNumericLabels") ? !this.selectedActivity.showNumericLabels : false;
          this.orginalselectedActivity = response.data.result;
          if (this.mode && (this.mode == "copy" || this.mode == "revise")) {
            this.selectedActivity.id = 0;
          }
          this.selectedActivityTypeId = this.selectedActivity.typeId;
          const completedBys = response.body.result.completedBy || [];
          this.completedByFilter =
            completedBys &&
            completedBys.map(completedBy => ({
              value: completedBy,
              name: completedBy.name
            }));
          if (!this.completedByFilter.length) {
            this.dirty = true;
          }
          const canViewBys = ["Principal-Investigator"];
          if (response.body.result.canViewBy && response.body.result.canViewBy.length) {
            this.canViewFilter =
              response.body.result.canViewBy &&
              response.body.result.canViewBy.map(canView => ({
                value: canView
              }));
          } else {
            this.canViewFilter =
              canViewBys &&
              canViewBys.map(canViewBy => ({
                value: canViewBy
              }));
          }
          const languages = response.body.result.language || [];
          const filteredLanguages =
            languages &&
            languages.map(language => ({
              language_id: language.language_id,
              display_name: language.display_name
            }));
          const defaultLanguage = this.getDefaultLanguage(filteredLanguages);
          if (defaultLanguage) {
            filteredLanguages.push(defaultLanguage);
          }
          Object.assign(this.languagesFilter, filteredLanguages);
          Object.assign(this.selectedLanguagesOnEdit, filteredLanguages);
          const tagIds = response.body.result.tags || [];
          this.selectedActivity.tags = tagIds;

          if (this.tags.length) {
            this.setTagsData();
          } else {
            setTimeout(() => {
              this.setTagsData();
            }, 500);
          }
          if (this.isRestrictedForHideStepNumbers()) {
            this.showMessageForHideStepNumbersRestiction();
          }
        })
        .catch(error => {
          this.$toastr.error(error && error.body ? error.body.message : "Error in getting Activity details");
        });
    },
    getDefaultLanguage(addedLanguages) {
      const defaultLanguage = this.languages && this.languages.find(o => o.language_culture == "EN");
      const isDefaultAdded = addedLanguages.findIndex(o => o.language_id === defaultLanguage.language_id);
      if (isDefaultAdded > -1) {
        return false;
      } else {
        return {
          active: defaultLanguage.active,
          display_name: defaultLanguage.languageName,
          language_culture: defaultLanguage.language_culture,
          language_id: defaultLanguage.language_id,
          name: defaultLanguage.name
        };
      }
    },
    setTagsData() {
      if (this.tags.length > 0) {
        this.selectedTagNames = this.selectedActivity.tags.map(item => this.tags.filter(tag => tag.id == item)[0].name);
        this.tagsFilter = this.selectedActivity.tags.map(item => this.tags.filter(tag => tag.id == item)[0]);
      }
    },
    skipForNow() {
      if (this.studyId) {
        // Back to study Config Activity Tab
        this.$router.push({
          name: this.$route.name == "data-capture-form-activity-details" ? "forms-list" : "study-activities",
          params: { studyId: this.studyId }
        });
      } else {
        this.$router.push({
          name: "activity-library-homepage"
        });
      }
    },
    createActivity(autoSave = false) {
      const removeItems = ["Patient/Participant", "Observer/Caregiver"];
      if (this.selectedActivity && this.selectedActivity.canViewBy && this.selectedActivity.canViewBy.length > 0) {
        const newArray = this.selectedActivity.canViewBy.filter((value) => {
          return !removeItems.includes(value)
        });
        this.selectedActivity.canViewBy = newArray;
      }
      this.selectedActivity.type = this.activityTypes.filter(item => item.id == this.selectedActivityTypeId)[0].type;
      //CSSRS form
      if (!autoSave) {
        if (this.mode === "revise" && this.selectedActivity && this.selectedActivity.customClinRO && (this.selectedActivity.customView === "CSSRS_BASELINE" || this.selectedActivity.customView === "CSSRS_SINCE_LAST")) {
          swal({
            title: "You cannot revise this activity.",
            type: "warning",
            showCancelButton: false,
            cancelButtonColor: "#4C8CE4",
            cancelButtonText: "Ok"
          }).then(({ dismiss }) => {
            if (dismiss != "overlay") {
              if (this.studyId) {
                this.$router.push({
                  name: "forms-list"
                });
              } else {
                this.$router.push({
                  name: "activity-library-homepage"
                });
              }
            }
          });
          return;
        }
      }
      if (this.selectedActivityConfig.custom_footer == "R" && this.selectedActivity.customFooter.length == 0) {
        this.customFooterHasError = true;
        if (!autoSave) {
          this.$toastr.error("Custom Footer must be filled");
        }
        return false;
      }
      if (this.dirty == true || this.activityId == 0) {
        this.$validator.validateAll().then(valid => {
          if (valid) {
            if (this.completedByFilter && this.completedByFilter.length == 0) {
              if (!autoSave) {
                this.$toastr.error("The user must be selected");
              }
            } else if (this.languagesFilter && this.languagesFilter.length == 0) {
              if (!autoSave) {
                this.$toastr.error("The language must be selected");
              }
            } else if (this.isRestrictedForHideStepNumbers()) {
              this.showMessageForHideStepNumbersRestiction();
            } else if (this.selectedActivity.timeToComplete) {
              if (Number(this.selectedActivity.timeToComplete) % 1 !== 0 || Number(this.selectedActivity.timeToComplete) > 999) {
                if (!autoSave) {
                  this.$toastr.error("Approximate minutes to complete field must an integer with 3 digits max.");
                }
                return;
              }
              const time = Number(this.selectedActivity.timeToComplete);
              if (time < 1 || time > 999) {
                if (!autoSave) {
                  this.$toastr.error("Time to complete cannot be less than 1 or greater than 999.");
                }
                return;
              }
              if (!autoSave) {
                this.$emit("onActivitySubmit", this.selectedActivity, this.revisionId);
              } else {
                this.$emit("onActivitySubmit", this.selectedActivity, this.revisionId, autoSave);
              }
            } else {
              if (!autoSave) {
                this.$emit("onActivitySubmit", this.selectedActivity, this.revisionId);
              } else {
                this.$emit("onActivitySubmit", this.selectedActivity, this.revisionId, autoSave);
              }
            }
          } else {
            if (!autoSave) {
              this.$toastr.error("Please populate all required fields");
            }
          }
        });
      } else {
        if (this.isPublishedEdit) {
          if (!autoSave) {
            this.$router.push({ name: "activity-library-homepage" });
          }
        } else {
          if (this.isRestrictedForHideStepNumbers()) {
            this.showMessageForHideStepNumbersRestiction();
          } else if (this.studyId) {
            if (!autoSave) {
              this.$router.push({
                name: this.$route.name == "data-capture-form-activity-details" ? "data-capture-form-activity-questions" : "activity-questions",
                params: {
                  activityId: this.activityId,
                  studyId: this.studyId,
                  taskId: this.taskId
                },
                query: { mode: this.mode }
              });
            }
          } else {
            if (!autoSave) {
              this.$router.push({
                name: "activity-questions",
                params: {
                  activityId: this.selectedActivity.id,
                  taskId: this.taskId
                },
                query: { mode: this.mode, revisionId: this.revisionId }
              });
            }
          }
        }
      }
    },
    showCheckboxesCompletedBy() {
      this.isDisplayCompletedByCheckBoxes = !this.isDisplayCompletedByCheckBoxes;
    },
    isCompletedBySelected(id) {
      return this.completedByFilter.findIndex(e => e.value === id) > -1;
    },
    isCanViewBySelected(index) {
      return this.canViewFilter && this.canViewFilter.findIndex(e => e.value === index) > -1;
    },
    hideCompletedByCheckBox() {
      this.eventListenerToHideCompletedByDropdown = document.addEventListener("click", event => {
        if (this.$refs["completed-by-select"] && this.$refs["completed-by-select"].contains(event.target)) {
        } else {
          this.isDisplayCompletedByCheckBoxes = false;
        }
      });
    },
    showCompletionDevices() {
      this.isDeviceCompletion = !this.isDeviceCompletion;
    },
    showProgressIndicator() {
      this.isProgressIndicator = !this.isProgressIndicator;
    },
    showCheckboxesTag() {
      this.searchedTag = "";
      this.isDisplayTagCheckboxes = !this.isDisplayTagCheckboxes;
    },
    onChangeCompletedByFilter(completedBy) {
      const isAvailableInCanView = this.canViewFilter.findIndex(role => role.value == completedBy.value);

      if (isAvailableInCanView < 0) {
        this.canViewFilter.push(completedBy);
      }

      const optionIndex = this.completedByFilter.findIndex(element => element.value === completedBy.value);

      if (optionIndex === -1) {
        this.completedByFilter.push(completedBy);
      } else {
        this.completedByFilter.splice(optionIndex, 1);
      }
      const ids = this.completedByFilter.map(l => l.value);
      this.selectedActivity.completedBy = ids;
      this.activityTypePermission(completedBy);
    },
    activityTypePermission(completedByOld) {
      let completedBy = completedByOld;
      if (completedBy === undefined) {
        completedBy = "";
      }
      if (this.selectedActivity.type == "Survey" || this.selectedActivity.type == "Task") {
        const patient = this.selectedActivity.completedBy.includes("Patient/Participant");
        const caregiver = this.selectedActivity.completedBy.includes("Observer/Caregiver");
        if (patient || caregiver) {
          this.completedByList.forEach((data, i) => {
            data.value == "Patient/Participant" || data.value == "Observer/Caregiver" ? (this.completedByList[i].fieldDisabled = false) : (this.completedByList[i].fieldDisabled = true);
          });
        } else if (completedBy != "") {
          if (completedBy.value == "Patient/Participant" || completedBy.value == "Observer/Caregiver") {
            this.completedByList.forEach((data, i) => {
              data.value == "Patient/Participant" || data.value == "Observer/Caregiver" ? (this.completedByList[i].fieldDisabled = false) : (this.completedByList[i].fieldDisabled = false);
            });
          } else if (completedBy.value) {
            this.selectedActivity.completedBy == 0
              ? this.completedByList.forEach((data, i) => {
                  data.value == "Patient/Participant" || data.value == "Observer/Caregiver" ? (this.completedByList[i].fieldDisabled = false) : (this.completedByList[i].fieldDisabled = false);
                })
              : this.completedByList.forEach((data, i) => {
                  data.value == "Patient/Participant" || data.value == "Observer/Caregiver" ? (this.completedByList[i].fieldDisabled = true) : (this.completedByList[i].fieldDisabled = false);
                });
          }
        } else {
          this.completedByList.forEach((data, i) => {
            data.value == "Patient/Participant" || data.value == "Observer/Caregiver" ? (this.completedByList[i].fieldDisabled = true) : (this.completedByList[i].fieldDisabled = false);
          });
        }
      }
    },
    disabledPermission(completedBy) {
      if (this.selectedActivity.type == "Survey" || this.selectedActivity.type == "Task") {
        if (completedBy.fieldDisabled != undefined) {
          return completedBy.fieldDisabled;
        }
      }
      return false;
    },
    onChangeCanViewFilter(canViewBy) {
      const optionIndex = this.canViewFilter.findIndex(element => element.value === canViewBy.value);

      const isAvailableInCanComplete = this.completedByFilter.findIndex(role => role.value == canViewBy.value);

      if (optionIndex === -1) {
        this.canViewFilter.push(canViewBy);
      } else {
        this.canViewFilter.splice(optionIndex, 1);
        if (isAvailableInCanComplete !== -1) {
          this.completedByFilter = this.completedByFilter.filter(role => role.value !== canViewBy.value);
        }
      }
      const idS = this.canViewFilter.map(l => l.value);
      this.selectedActivity.canViewBy = idS;
    },
    hideLanguageCheckBox() {
      this.eventListenerToHideLanguageDropdown = document.addEventListener("click", event => {
        if (this.$refs["languages-select"] && this.$refs["languages-select"].contains(event.target)) {
        } else {
          this.isDisplayLanguageCheckBoxes = false;
        }
      });
    },
    hideDeviceCheckBox() {
      this.eventListenerToHideDeviceDropdown = document.addEventListener("click", event => {
        if (this.$refs["device-select"] && this.$refs["device-select"].contains(event.target)) {
        } else {
          this.isDeviceCompletion = false;
        }
      });
    },
    hideTagCheckBox() {
      this.eventListenerToHideTagDropdown = document.addEventListener("click", event => {
        if (this.$refs["tags-select"] && this.$refs["tags-select"].contains(event.target)) {
        } else {
          this.isDisplayTagCheckboxes = false;
        }
      });
    },
    isLanguageSelected(id) {
      return this.languagesFilter.findIndex(e => e.language_id === id) > -1;
    },
    isSelectedLanguageOnEdit(id) {
      return this.selectedLanguagesOnEdit.findIndex(e => e.language_id === id) > -1;
    },
    isDeviceSelected(value) {
      return this.selectedDevices && this.selectedDevices.findIndex(e => e.value === value) > -1;
    },

    // for custom indicator dropdown start
    onIndicatorProgressClick(IP) {
      this.selectedProgressBar = IP;
      const v = document.getElementById("showProgressIndicator");
      v.style.display = "none";
    },

    onDeviceChange(device) {
      const optionIndex = this.selectedDevices.findIndex(element => element.value === device.value);
      if (
        this.selectedDevices.some(el => {
          return el.value == "website";
        }) ||
        device.value == "website"
      ) {
        this.selectedDevices = [];
      }
      if (optionIndex === -1) {
        this.selectedDevices.push(device);
      } else {
        this.selectedDevices.splice(optionIndex, 1);
      }
      const ids = this.selectedDevices.map(l => l.value);
      this.selectedActivity.selectedDevices = ids;
    },
    onChangeLanguageFilter(language) {
      const optionIndex = this.languagesFilter.findIndex(element => element.language_id === language.language_id);
      if (optionIndex === -1) {
        this.languagesFilter.push(language);
      } else {
        this.languagesFilter.splice(optionIndex, 1);
      }
      const ids = this.languagesFilter.map(l => l.language_id);
      this.selectedActivity.languages = ids;
    },
    isTagSelected(id) {
      return this.tagsFilter.findIndex(e => e.id === id) > -1;
    },
    onChangeTagFilter(tag) {
      const optionIndex = this.tagsFilter.findIndex(element => element.id === tag.id);

      if (optionIndex === -1) {
        this.tagsFilter.push(tag);
        this.tagsFilter = _.orderBy(this.tagsFilter, [tag => tag.name.toLowerCase()]);
      } else {
        this.tagsFilter.splice(optionIndex, 1);
      }

      const ids = this.tagsFilter.map(l => l.id);
      this.selectedActivity.tags = ids;
      const names = this.tagsFilter.map(l => l.name);
      this.selectedTagNames = names;
      this.dirty = true;
    },
    removeSelectedTag(index) {
      this.selectedTagNames.splice(index, 1);
      this.selectedActivity.tags.splice(index, 1);
      this.tagsFilter.splice(index, 1);
    },
    characterLimitValidation(event, autoSave = false) {
      if (this.selectedActivity.customFooterText && this.selectedActivity.customFooterText != "") {
        this.selectedActivity.customFooter = true;
      } else {
        this.selectedActivity.customFooter = false;
      }

      const quill = event.quill;
      this.customFooterHasError = !!(event.text.length == 0 && this.selectedActivityConfig.custom_footer == "R");
      if (event.text.length > this.customFooterLimit) {
        if (!autoSave) {
          toastr.error(`Character limit cannot exceed ${this.customFooterLimit}.`);
        }
      }
      quill.deleteText(this.customFooterLimit, quill.getLength());
    },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        this.createActivity(true);
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    },
    resetAutoSave() {
      this.stopAutoSave();
      this.startAutoSave();
    },
    checkOldAlignments(activityData) {
      const activityDataObj = JSON.parse(activityData);
      const reducerFn = list => (arr, role) => {
        const found = this[list].find(r => r.value.replace(/[_\- ]/g, "") == role.replace(/[_\- ]/g, ""));
        if (found) {
          arr.push(found.value);
        }
        return arr;
      };
      if (Array.isArray(activityDataObj.completedBy)) {
        activityDataObj.completedBy = activityDataObj.completedBy.reduce(reducerFn("completedByList"), []);
      }
      if (Array.isArray(activityDataObj.canViewBy)) {
        activityDataObj.canViewBy = activityDataObj.canViewBy.reduce(reducerFn("canViewList"), []);
      }
      if (!!activityDataObj.questions && activityDataObj.questions.length > 0) {
        activityDataObj.questions.map(question => {
          alignmentService.addAlignmentsForAPP(question);
        });
        return activityDataObj;
      }
    }
  },
  beforeDestroy() {
    this.stopAutoSave();
  }
};
</script>

<style scoped lang="scss">
.close-icon {
  padding: 7px 7px 0px 0px;
  opacity: 0.5;
  cursor: pointer;
}

.add-import-activity-json-modal__container {
  width: 518px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 42px;
  flex-direction: column;

  .import-success-header-text {
    font-weight: bold;
    font-size: 24px;
    line-height: 1.33;
  }

  .import-success-text {
    font-size: 18px;
    padding-top: 18px;
    padding-bottom: 20px;
  }
}

.json-file-upload {
  display: block;
  font-size: 20px;
  filter: alpha(opacity=0);
  width: 135px;
  overflow: hidden;
  height: 40px;
  max-height: 50px;
  max-width: 200px;
  opacity: 0;
  position: absolute;
  right: 41px;
  text-align: right;
  top: 17px;
}

.custom-json-upload-btn {
  border-radius: 4px !important;
  line-height: 16px;
  height: 35px;
  margin-right: 5px;
}

.upload-file-img {
  background-color: #fff;
  margin-right: 2px;
  margin: 0px !important;
  border-radius: 2px;
  position: relative;
  right: 8px;
  bottom: 3px;
}

/deep/ .quill-editor {
  &.bg-white {
    position: relative;

    // border-top: 1px solid #ccc;
    .ql-toolbar {
      &.ql-snow {
        background: transparent;
        border-bottom: none;
        border-top: none;
        padding: 4px;
        float: right;
        border-left: none;
        z-index: 9;
        position: relative;

        .ql-formats {
          margin-right: 0px;
          border: 1px solid #ccc;
          border-radius: 2px;
          margin-right: 10px;

          .ql-active {
            box-shadow: 0 2px 2px 0 rgb(119, 119, 120);
          }

          button {
            height: 29px;
            padding: 4px 4px;
          }

          button:not(:last-child) {
            border-right: 1px solid #ccc;
          }
        }

        .ql-formats:last-child {
          border-right: 1px solid #ccc;
        }

        .ql-stroke {
          stroke: #ccc;
        }

        .ql-fill,
        .ql-snow .ql-stroke.ql-fill {
          fill: #ccc;
        }
      }
    }

    .ql-container {
      background-color: #f5f8fa;
      border-radius: 2px;
      margin-top: -1px;
      border-top: 1px solid #ccc;
      color: #495057;
      font-size: 14px;

      .ql-editor {
        height: auto;
        min-height: 0px;
      }

      .ql-editor.ql-blank::before {
        font-style: normal;
        font-size: 14px;
        color: #b1b4b5 !important;
        font-weight: normal;
      }
    }
  }

  &.instruction-screen {
    .ql-toolbar {
      &.ql-snow {
        .ql-formats {
          margin-top: 5px;
        }
      }
    }

    .ql-container {
      .ql-editor {
        min-height: 100px;
      }
    }
  }
}

.activity-form {
  min-height: 647px;
  position: relative;
  padding-top: 21px !important;
  padding-right: 30px !important;
}

body {
  color: #333;
}

.h2,
h2 {
  font-size: 30px;
  margin: 20px 0 10px;
}

.h3,
h3 {
  font-size: 24px;
  color: #333;
}

.h4,
h4 {
  font-size: 18px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.h5,
h5 {
  font-size: 14px;
  margin: 10px 0;
}

.h6,
h6 {
  font-size: 12px;
  margin: 10px 0;
  color: #333;
}

.btn {
  font-size: 14px;
}

.col-xs-12 {
  width: 100%;
}

.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  float: left;
  //flex: none;
  display: block;
}

.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  position: relative;
  min-height: 1px;
  padding-right: 15px;
  padding-left: 15px;
}

.col-xs-10 {
  width: 83.33333333%;
}

.panel-default {
  border-color: #ddd;
}

.panel {
  margin-bottom: 20px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.row {
  display: block;

  &:after {
    content: "";
    clear: both;
    display: block;
  }
}

.activity-form-information {
  padding-left: 25px;
}

.color_959fa4 {
  color: #959fa4 !important;
}

@media (min-width: 768px) {
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
    display: block;
  }

  .col-sm-12 {
    width: 100%;
  }

  .col-sm-10 {
    width: 83.33333333%;
  }

  .col-sm-4 {
    width: 33.33333333%;
    max-width: 33.33333333%;
  }

  .col-md-2 {
    flex: none;
  }
}

@media (min-width: 992px) {
  .col-md-1,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-md-10,
  .col-md-11,
  .col-md-12 {
    float: left;
    flex: none;
  }

  .col-md-2 {
    width: 16.66666667%;
  }

  .col-md-10 {
    width: 83.33333333%;
  }

  .col-md-12 {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .col-lg-1,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12 {
    float: left;
    display: block;
  }

  .col-lg-2 {
    width: 16.66666667%;
  }

  .col-lg-10 {
    width: 82.33333333%;
  }

  .col-lg-11 {
    width: 91.66666667%;
  }
}

// // END of style for quick fixes bootstrap after migration (before redesign should be removed)

.bg-color {
  background-color: #f5f8fa;
  background-size: cover;
  // height: 100%;
  // min-height: 100vh;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

.collapse_card {
  border: 1px solid #d3dfe4 !important;
  background-color: #f5f8fa;
  padding-left: 5px;
}

.icon_section {
  width: 28px;
  height: 28px;
  border-radius: 2px;
  background-color: #d3dfe4;
  display: inline-block;
  text-align: center;
  padding-top: 5px;
}

.read_only_card {
  border-left: 6px solid #d3dfe4 !important;
}

.navbar-style {
  background: linear-gradient(to left, #7478e6, #09b9e0);
}

.btn {
  border-radius: 25px;
}

.new-heading {
  font-size: 20px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #666669;
}

.container-style {
  border-radius: 3px;
  background-color: #ffffff;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.card {
  border-radius: 3px;
  background-color: #f5f8fa;
  border: solid 1px #d3dfe4;
  padding: 5px 20px;
  margin: 10px 0px 20px 0px;
}

.cardX {
  margin: 0 auto 2rem;
  box-shadow: 0 0.0625em 0.2em 0 rgba(0, 0, 0, 0.1), 0 0.7em 0 -0.3em #f2f2f2, 0 0.5em 0.1875em -0.25em rgba(0, 0, 0, 0.2), 0 1em 0 -0.6em #e5e5e5, 0 1em 0.1875em -0.5em rgba(0, 0, 0, 0.2), 0 1em 0 -0.6em #e5e5e5, 0 1em 0.1875em -0.5em rgba(0, 0, 0, 0.2) !important;
}

.doc_desc {
  display: inline-block;
  word-break: break-all;
}

.font-style {
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1f95f2;
}

.mins_text {
  position: absolute;
  top: 8px;
  right: 15px;
  color: #959fa4;
  font-size: 14px;
}

.header-style {
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
}

.edit_only_screen {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
}

.add-btn {
  font-size: 14px;
  min-width: 150px;
  border: 1px solid#f06559;
  color: #f06559;
  background: transparent;
}

.save_btn {
  width: 100px;
}

.form-control {
  border-radius: 2px;
  background-color: #f5f8fa;
  height: 40px;

  &:disabled {
    &:hover {
      cursor: not-allowed !important;
    }
  }
}

.misplaced-card {
  border-radius: 8px;
  background-color: #ffffff;
  border: solid 1px #d3dfe4;
}

.edit-btn {
  padding: 5px 15px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 1px #d3dfe4;
  color: #1f95f2;
}

.radio-style {
  bottom: 2px;
  text-align: center;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.close-style {
  padding: 15px 15px 0px 0px;
}

.back_link {
  color: #666669;
}

.survey_title {
  color: #666669;
  font-size: 14px;
}

.input-color {
  background-color: #f7f7f7;
  border: 1px solid #cccccc;
  border-radius: 3px;
}

.divider {
  margin-top: 30px;
  margin-bottom: 28px;
  border: 1px solid #d3dfe4;
}

.grey1 {
  margin-bottom: 22px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 23px;
  float: left;
  margin-right: 10px;
}

/* Hide default HTML checkbox */
.switch input {
  display: none;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #ccc;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}

input:checked + .slider {
  border: 2px solid #48bf7a;
}

input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  /*content: '✓';*/
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.filds_section {
  border-radius: 8px;
  padding: 0 10px 10px;
  background-color: #ffffff;
  border: solid 1px #d3dfe4;
  min-height: 150px;
}

.switch-option {
  float: left;
  width: 100%;
}

.pad22 {
  padding-bottom: 22px;
}

.grpdwn,
.pt-10 {
  opacity: 0.7;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: #666669;
  margin-bottom: 5px;
}

.pt-20 {
  margin-top: 100px;
  margin-bottom: 20px;
}

.back_link {
  color: #666669;
}

.survey-error {
  font-size: 14px;
  color: #f06559;
}

.modal-close {
  font-size: inherit;
  color: #000;
}

.add-tag {
  padding-left: 30px;
}

.add-tag-btn {
  cursor: pointer;
  width: 92px;
  border-radius: 3px;
  background-color: #ffffff;
  border: solid 3px #4c8ce4;
  text-align: center;
  padding: 4px;
  color: #4c8ce4;
}

.import-json-btn {
  height: 36px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 4px;
  border: none;
  position: relative;
  bottom: 12px;
}

.continue-btn {
  width: 122px;
  height: 36px;
  cursor: pointer;
  background-color: #4c8ce4;
  border-radius: 100px;
  border: solid 2px #4c8ce4;
  outline: none;
  color: #fff;
}

.cancel-btn {
  width: 122px;
  height: 36px;
  background-color: transparent !important;
  border-radius: 100px;
  border: transparent !important;
  cursor: pointer;
  outline: none;
  color: #4c8ce4;
  font-size: 14px;
}

.setting-btn-text {
  position: relative;
  right: 5px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  color: #b0bac9;
}

.required {
  color: #ff0000;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
}

.requrired-field {
  font-family: Roboto;
  font-size: 12px;
  position: absolute;
  bottom: 0;
  line-height: 2.5;
  letter-spacing: normal;
  color: #000000;
}

.Grop-dropdown {
  height: 40px !important;
}

.add-tags {
  width: 98px;
  height: 28px;
  border-radius: 10px;
  background-color: #4c8ce4;
}

.display-tag-text {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 26px;
  letter-spacing: normal;
  display: flex;
  justify-content: center;
}

.display-tag-box {
  width: auto;
  height: 28px;
  border-radius: 4px;
  background-color: #f5f8fa;
  cursor: pointer;
  padding: 0 10px;
  border: solid 1px #d3dfe4;
}

.display-tag-box-selected {
  width: auto;
  height: 28px;
  border-radius: 4px;
  background-color: #4c8ce4;
  cursor: pointer;
  padding: 0 10px;
}

.display-tag-box-selected-text {
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 26px;
  letter-spacing: normal;
  color: #ffffff;
  display: flex;
  justify-content: center;
}

#showCompletionDevices {
  background: #fff;
  position: absolute;
  top: 0px;
  width: 95% !important;
  height: fit-content;
  border-radius: 4px;
  padding: 10px;
  overflow: auto;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

#showProgressIndicator {
  background: #fff;
  position: absolute;
  top: -3px;
  left: -3.5px;
  width: 96%;
  height: fit-content;
  border-radius: 4px;
  padding-bottom: 10px;
  overflow: hidden;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

#showProgressIndicator label:first-child {
  background-color: #f5f8fa;
}

#showCheckboxesTags {
  /* display: none; */
  background: #fff;
  position: absolute;
  top: 45px;
  width: 95%;
  height: 230px;
  border-radius: 3px;
  padding: 10px;
  overflow: scroll;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
  margin-top: -50px;
}

#showCheckboxesTags label {
  font-size: 14px;
  color: #000;
  margin-left: 8px;
  float: left;
  width: 275px;
  line-height: 25px;
}

#showCheckboxesLanguage,
#showCompletionDevices {
  font-size: 14px;
  color: #000;
  float: left;
  width: 275px;
  line-height: 30px;
}

#showProgressIndicator label {
  font-size: 14px;
  color: #000;
  float: left;
  width: 275px;
  line-height: 30px;
  margin-bottom: 0px;
}

#showCheckboxesCompletedBy {
  /* display: none; */
  background: #fff;
  position: absolute;
  top: 136px;
  width: 120%;
  height: 313px;
  border-radius: 3px;
  padding: 10px 0px 10px 10px;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

#showCheckboxesCompletedBy label {
  font-size: 14px;
  color: #000;
  margin-left: 8px;
  float: left;
  width: auto;
  line-height: 30px;
}

.check_label_input input {
  float: left;
  line-height: 30px;
  margin-top: 8px;
  -webkit-margin-before: 8px;
}

.filter-form-box .select-scroll::-webkit-scrollbar {
  width: 8px;
  /* width of the entire scrollbar */
}

.filter-form-box .select-scroll::-webkit-scrollbar-track {
  background: transparent;
  /* color of the tracking area */
}

.filter-form-box .select-scroll::-webkit-scrollbar-thumb {
  background-color: #b0bac9;
  /* color of the scroll thumb */
  border-radius: 20px;
  /* roundness of the scroll thumb */
  border: 3px solid transparent;
  /* creates padding around scroll thumb */
}

.select-scroll {
  scrollbar-width: thin;
  /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent;
  /* scroll thumb & track */
}

.filter-form-box select {
  width: 100%;
  font-size: 12px;
  height: 40px;
  border-radius: 3px;
  background-color: #f5f8fa;
  color: #666669;
  border-radius: 2px;
  border: solid 1px #ced4da;
}

.filter-form-box ul {
  width: 100%;
  font-size: 14px;
  height: 40px;
  border-radius: 3px;
  background-color: #f5f8fa;
  color: #666669;
  border-radius: 2px;
  border: solid 1px #ced4da;
}

.filter-form-box ul li {
  list-style-type: none;
  padding: 9px 0;
}

.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  // top: 0;
  bottom: 0;
}

.hoverInOverSelect {
  position: unset !important;
}

.language-search-bar {
  width: 100%;
  height: 33px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
  margin-bottom: 10px;
}

.tag-box {
  width: 45%;
}

.activity-form img {
  float: left;
  margin-top: 4px;
  margin-right: 4px;
}

.import-json-btn img {
  background-color: #fff;
  margin: 0 10px 0 0;
  border-radius: 2px;
}

.th-comman-select-box {
  height: 31px !important;
  line-height: 17px;
  color: #4a4a4a !important;

  .dropdown-item {
    &:hover {
      background-color: #f8f9fa !important;
    }
  }

  option[disabled]:first-child {
    display: none;
  }
}

.progress-indicator {
  select:first-child {
    color: #c5d1d6 !important;
  }
}

select.activity-type {
  color: #000;
}

select.activity-type:focus {
  color: #000000 !important;
}

.activity-type option:first-of-type {
  color: #b0bac9;
}

.activity-type option {
  color: #000000;
  background-color: #fff;
}

select.activity-type.color-light {
  color: #b0bac9;
}

.can-view {
  width: auto;
  height: 30px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.14;
  letter-spacing: normal;
  color: #000000;
}

.completed-by {
  width: 202px;
  height: 30px;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.14;
  letter-spacing: normal;
  color: #000000;
}

.chip-container {
  margin-top: 15px;
  width: 600px;
  min-height: 34px;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;

  .chip {
    max-width: 200px;
    min-width: 80px;
    width: auto;
    margin: 4px;
    background: #f5f8fa;
    border: 1px solid rgba(0, 0, 0, 0.2);
    padding: 3px 10px;
    border-radius: 5px;
    align-items: center;

    i {
      cursor: pointer;
      margin-left: 8px;
      color: #4c8ce4;
    }
  }
}

textareaclass {
  resize: none !important;
  overflow: hidden !important;
  min-height: 50px !important;
  max-height: 100px !important;
}

.display-tag-box-selected .color_4c8ce4 {
  color: #fff;
}

.mt__4 {
  margin-top: -4px;
}

.mt__11 {
  margin-top: -11px;
}

#select-completed-by,
#select-Language {
  background-position: right 50% !important;
  background-repeat: no-repeat;
  background-image: url(/static/img/arrow-down.png);
}

.cursor-pointer {
  cursor: pointer;
}

select option.selected {
  color: #c5d1d6;
}

.pi-width {
  width: 100% !important;
  padding: 0 16px !important;
}

.progress-input .th-comman-select-box {
  color: #4a4a4a !important;
  text-transform: capitalize;
}

.progress-input textarea:focus,
input:focus {
  outline: none !important;
}

.activity-type-select li .no-of-tags {
  background-color: #d3dfe4;
  padding: 2.5px 6px;
  border-radius: 2px;
  margin-left: 4px;
  font-size: 13px;
  color: #4c8ce4;
  font-weight: bold;
}
</style>
